import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Link } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'center',
    marginRight: '7vw',
    marginLeft: '7vw'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  },
  repository: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '8vh',
    color: '#b15858'
  },
  url: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '1vh'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>snmp-fiberhome</Typography>
          <Typography className={classes.description} >NPM module developed to communicate with Fiberhome OLTs using the SNMP protocol. The module is capable of managing the OLT, Slots, Cards, Pon ports and ONUs by performing read and write functions directly in OLT. The module was developed using TDD and the tests used the Tape module.</Typography>
          <Typography className={classes.repository}>npmjs</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="https://www.npmjs.com/package/snmp-fiberhome"
              target="_blank"
            >
              https://www.npmjs.com/package/snmp-fiberhome
              </Link>
          </Typography>
          <Typography className={classes.repository}>Repository</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="https://github.com/davibaltar/snmp-fiberhome"
              target="_blank"
            >
              https://github.com/davibaltar/snmp-fiberhome
              </Link>
          </Typography>
        </Grid>
      </Grid>
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    </div>
  );
};


export default Header;